import { DeepReadonly } from '@/scenarios/legacy-player/lib/deepReadonly';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { Stream } from '../types/config';

export const useOnCurrentStreamChanged = (
    onCurrentStreamChanged: (
        currentStream: DeepReadonly<Omit<Stream, 'drmConfig'>> | undefined
    ) => void
) => {
    useInstanceEffect(
        (instance) => instance.onCurrentStreamChange(onCurrentStreamChanged),
        [onCurrentStreamChanged]
    );
};
